/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --width: auto;
  --font-size: var(--nve-ref-font-size-100);
  --font-weight: var(--nve-ref-font-weight-semibold);
  --border-radius: var(--nve-ref-border-radius-xl);
  --color: var(--nve-sys-text-muted-color);
  --cursor: pointer;
  --text-transform: capitalize;
  --nve-sys-interaction-state-ratio: 0;
}

[internal-host] {
  --_icon-button-color: var(--color);
  width: var(--width);
  gap: var(--nve-ref-space-xs);
  padding: var(--nve-ref-size-200) var(--nve-ref-size-300) var(--nve-ref-size-200) var(--nve-ref-size-200);
  color: var(--color);
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  line-height: var(--nve-ref-font-size-500);
  background-image: linear-gradient(
    color-mix(
        in oklab,
        var(--nve-sys-interaction-state-base) 100%,
        var(--nve-sys-interaction-state-mix) var(--nve-sys-interaction-state-ratio)
      )
      0 0
  ) !important;
  border-radius: var(--border-radius);
  cursor: var(--cursor);
  text-transform: var(--text-transform);
  display: inline-flex;
  align-items: center;
  border: 0;
  position: relative;
}

nve-progress-ring,
nve-icon-button {
  --height: var(--nve-ref-size-700);
  --width: var(--nve-ref-size-700);
  cursor: pointer;
}

nve-icon-button#number-icon {
  box-sizing: content-box;
  border: var(--nve-ref-border-width-md) solid var(--nve-ref-border-color-emphasis);
  border-radius: 100%;
  --color: var(--_icon-button-color);
  --height: var(--nve-ref-size-600);
  --width: var(--nve-ref-size-600);
  --background: transparent;
}

nve-icon-button[interaction='emphasis'] {
  --background: var(--nve-sys-support-success-color);
  --color: var(--nve-sys-text-white-color);
}

:host(:state(selected)) {
  --color: var(--nve-sys-text-emphasis-color);
  --font-weight: var(--nve-ref-font-weight-semibold);
  --nve-sys-interaction-state-ratio: var(--nve-sys-interaction-state-ratio-hover);
}

:host(:state(disabled)) {
  --color: var(--nve-sys-interaction-disabled-color);
  --cursor: not-allowed;
}

:host(:hover:not(:state(disabled), :state(selected))) {
  --nve-sys-interaction-state-ratio: var(--nve-sys-interaction-state-ratio-hover);
}

:host([container='condensed']) div {
  padding: var(--nve-ref-size-200);
}
